// extracted by mini-css-extract-plugin
module.exports = {"audit":"Brand_audit-1mqUU","upload":"Brand_upload-3eZZN","holder":"Brand_holder-Gwk-b","icon":"Brand_icon-2NXaK","button":"Brand_button-1XqJQ","alert":"Brand_alert-3NmQw"};